import React from 'react'
import { Link } from 'react-router-dom';
const getInTouch = props =>{
     return(
        <section>
            <div style={ {backgroundColor : '#F2F2F2', marginTop: '-10px'} } className="py-5">
                <div className="ms-width px-5">
                    <h2 className="heading2 fw-sb text-color1 text-center text-md-left">Want to learn where you stand?</h2>
                    <div className="mt-1 d-flex flex-md-row flex-column justify-content-between align-items-center">
                        <h2 className="heading2  fw-sb text-color1 text-center text-md-left">Let's get in <span className="text-color2"> touch.</span></h2>
                        <Link to="/checkeligibility" type="button" className="btn btn-explore bg2 text-white">Check Eligibility</Link>
                    </div>
                </div>
            </div>
        </section>
     )
}

export default getInTouch;